import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAllTrainingPlans } from '@/api/trainingPlanService';
import { queryKeys } from '@/lib/queryKeys';
import type { AllTrainingPlans } from '@/types/planTypes';

export const useAdminTrainingPlans = () => {
  const { data: plans = [], isLoading } = useQuery<AllTrainingPlans[]>({
    queryKey: queryKeys.trainingPlans,
    queryFn: getAllTrainingPlans,
    staleTime: 4 * 60 * 60 * 1000,
  });

  const plansMap = useMemo(() => new Map(plans.map((p) => [p.plan_id, p])), [plans]);

  return { plans, plansMap, isLoading };
};
